<template>
  <div class="tour-gallery-slider">
    <div ref="swiper" class="swiper">
      <div class="swiper-wrapper" ref="swiper">
        <div
          v-for="({ id, path, url }, index) in getGallery"
          :key="id"

          class="tour-gallery-slider__item u-bg-cover u-clickable swiper-slide"
          @click="showPopupSlider(index)"
        >
          <img
            v-if="index <= 1"
            class="tour-gallery-slider__img"
            :src="path || url"
          />
          <img
            v-else
            class="tour-gallery-slider__img lazyload"
            v-lazy="path || url"
          />
        </div>
      </div>
    </div>
    <div class="tour-gallery-slider__pagination">
      <div class="tour-gallery-slider__pagination-icon u-flex-shrink-0">
        <svg-inline class="u-fill-deep-current">
          <icon icon="icon-toolbar-image" />
        </svg-inline>
      </div>
      <div
        ref="pagination-text"
        class="tour-gallery-slider__pagination-text font-h2"
      ></div>
    </div>
    <popup-photo-slider
      v-model="popups.slider"
      :photos="getGallery"
      :initial-slide="initialSlide"
    />
  </div>
</template>

<script>
import Swiper, { Pagination } from "swiper";
import "swiper/swiper.scss";
import SvgInline from "@/components/ui-kit/svg-inline/index.vue";
import Icon from "@/components/icons/index.vue";
import PopupPhotoSlider from "@/components/molecules/popup-photo-slider/index.vue";

export default {
  components: {
    SvgInline,
    Icon,
    PopupPhotoSlider,
  },
  props: {
    gallery: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      swiperInstance: null,
      popups: {
        slider: false,
      },
      initialSlide: 0,
    };
  },
  computed: {
    getGallery() {
      return this.gallery.map(({ MEDIA_BIG }, index) => ({
        id: index,
        path: MEDIA_BIG
      }))
    },
  },
  mounted() {
    this.$nextTick(this.initSlider);
  },
  beforeDestroy() {
    this.swiperInstance?.destroy();
  },
  methods: {
    initSlider() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        touchReleaseOnEdges: true,
        observer: true,
        pagination: {
          el: this.$refs["pagination-text"],
          renderCustom: (swiper, current, total) =>
            this.$t("pagination.text", { current, total }),
          type: "custom",
        },
        modules: [Pagination],
      });
    },
    showPopupSlider(index) {
      this.initialSlide = index;
      this.popups.slider = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.tour-gallery-slider {
  position: relative;
  margin: 0 #{- (var.$inner-pd)};

  &__img {
    width: 100%;
    height: 100%;
    position: absolute;
    object-fit: cover;
  }
  &__item {
    height: 256px;
    position:relative;
    @include mixin.size-sm-min() {
      height: 408px;
    }
  }

  &__pagination {
    position: absolute;
    right: var.$inner-pd;
    bottom: var.$inner-pd;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(var.$black, 0.75);
    color: var.$white;
    border-radius: 36px;
    padding: 14px 20px;
    z-index: 1;

    &-icon {
      width: 20px;
      margin-right: 6px;
    }
  }
}
</style>
